import qs from 'qs';

export class DocumentTypesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentTypes(params) {
    return this.#http.get('/api/document-types', {
      params,
    });
  }

  async createDocumentTypes(body, params) {
    return this.#http.post('/api/document-types', body, { params });
  }

  async getDocumentTypeById({ documentTypeId, ...params }) {
    return this.#http.get(`/api/document-types/${documentTypeId}`, {
      params,
      paramsSerializer: {
        serialize: params => qs.stringify(params, { arrayFormat: 'repeat', encode: false }),
      },
    });
  }

  async editDocumentType(body) {
    return this.#http.put(`/api/document-types/${body.id}`, body);
  }

  async deleteDocumentType({ documentTypeId, id, reassignToDocumentTypeId, ...params }) {
    return this.#http.delete(`/api/document-types/${documentTypeId}`, {
      params: { ...params, reassignToDocumentTypeId },
    });
  }

  async reorderDocumentType({ categoryId, list }) {
    return this.#http.put(`/api/document-types/reordering/document-categories/${categoryId}`, list);
  }

  async setDocumentTypeSystemKey({ documentTypeId, systemKey }) {
    return this.#http.put(`/api/document-types/${documentTypeId}/system-key`, { systemKey });
  }

  async setDocumentTypeClassificationTier({ documentTypeId, classificationTier }) {
    return this.#http.put(`/api/document-types/${documentTypeId}/classification-tier`, {
      classificationTier,
    });
  }

  async setDocumentTypeContinuationHint({ documentTypeId, aiBoundaryContinuationHint }) {
    return this.#http.put(`/api/document-types/${documentTypeId}/continuation-hint`, {
      aiBoundaryContinuationHint,
    });
  }

  async resolveDocumentType({ documentTypeId }) {
    return this.#http.get(`/api/document-types/${documentTypeId}/resolve`);
  }
}
